<template>
  <nk-page>
    <template #badges>
      <nk-badge :showHome="false">
      </nk-badge>
    </template>

    <div class="container-fluid h-100 d-flex flex-column" ref="container">
      <div class="row mb-3">
        <div class="card nk-card w-100">
          <div class="card-body form-container p-0">
            <div class="row">
              <div class="col-12">
                <nk-col-form-group :label="$t('core.generate-pattern.f.count') + ':'" :labelSizes="{ sm: 2 }" :dataSizes="{ sm: 4 }">
                  <nk-input :tabindex="103" v-model="localData.count"></nk-input>
                </nk-col-form-group>
              </div>
              <div class="col-12">
                <nk-col-form-group :label="$t('core.generate-pattern.f.pattern') + ':'" :labelSizes="{ sm: 2 }" :dataSizes="{ sm: 4 }">
                  <nk-dropdown :tabindex="104" v-model="localData.pattern" :data="patterns" :options="itemsDropOptions"></nk-dropdown>
                </nk-col-form-group>
              </div>
              <div class="col-12">
                <nk-col-form-group :label="$t('core.generate-pattern.f.template') + ':'" :labelSizes="{ sm: 1 }" :dataSizes="{ sm: 11 }">
                  <div class="pattern-box" style="">
                    <div v-for="(p, index) in beautyPatternItems" :key="index" class="pattern-item" style="">
                      <div class="pattern-item-title">{{ p.title }}</div>
                      <div v-if="p.extraItems?.length" class="pattern-item-extra-items">
                        <div v-for="(ex, inx) in p.extraItems" :key="inx" class="pattern-item-extra-item">
                          <span class="ml-1">{{ ex.title }}:</span>
                          <span class="text-orange">{{ ex.value }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <nk-input :tabindex="104" v-model="localData.pattern" disabled dir="ltr"></nk-input> -->
                </nk-col-form-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nk-page>
</template>

<script lang="ts">
  import { ICodePattern, ICodePatternSubject, ICodePatternRule } from '@/interfaces/views/core/code-pattern'
  import { defineComponent, PropType } from 'vue'
  import { post } from '@/plugins/nikan-api'
  import Endpoints from '@nikan/endpoints'
  import { IResponse, IResponseList } from '@/interfaces/base'
  import $sc from '~/plugins/shortcut.collection.js'
  import emptyId from '~/statics/empty-id'
  import validators, { Checker, isEmpty, VCustom } from '@/statics/validators'
  import { TYPE } from 'vue-toastification'

  interface ILocalData {
    count: number
    pattern: ICodePattern | null
  }

  interface IData {
    pageButtons: any[],
    localData: ILocalData,
    patterns: ICodePattern[],
    itemsDropOptions: any,
    validators: any,
  }

  export default defineComponent({
    name: 'generate-barcodes',
    components: {

    },
    modal: {
      size: 'MD',
      stateUID: "generate-barcodes"
    },
    props: {
      options: {
        type: Object,
        required: false
      },
      data: {
        type: Object as PropType<any>,
        required: false
      },
    },
    data(): IData {
      return {
        pageButtons: [
          {
            title: this.$t('save'),
            shortcut: $sc.find('save'),
            isPrimary: false,
            icon: 'save',
            // policyClaims: 'some claims',
            selfButton: true,
            handle: () => {
              // validate table
              if (this.validateInputs()) {
                this.handleSaveBtn()
              }
            },
          },
        ],
        localData: {
          count: 1,
          pattern: null
        },
        patterns: [],
        itemsDropOptions: {
          display: (item: ICodePattern) => item.name,
        },
        validators: {
          count: validators(
            new VCustom(
              (val: number, row: any) => {
                return val <= 100
              },
              () => this.$t('core.generate-pattern.m.max-100')
            )),
          pattern: validators('required'),
        }
      }
    },
    methods: {
      getCodePatternListData() {
        var wait = this.$wait(this.$refs.container, { size: 'large' })
        post(Endpoints.getUrl('codepattern.list'), { includeRules: true })
          .then((res: IResponseList<ICodePattern>) => {
            this.patterns = res.data.items.filter(x => x.entityType === this.options?.entitytType)
          })
          .catch((error: any) => {
            console.error(error)
          })
          .finally(() => {
            wait.end()
          })
      },
      handleSaveBtn() {
        switch (this.options?.entitytType) {
          case 'ProductBarcode':
            this.generateProductBarcodes()
            break
          case 'ProductFloatingBarcode':
            this.generateProductFloatingBarcodes()
            break
          default:
            this.$toast(this.$t('msg.save-success-doc-code'), { type: 'error' } as any)
            break
        }

      },
      validateInputs() {
        let checker = new Checker((name: String) => this.$t(`core.generate-pattern.f.${name}`))
        let errors = checker.test(this.localData, this.validators)

        this.validationToast(errors)
        return errors.length === 0
      },
      generateProductBarcodes() {
        var wait = this.$wait(this.$refs.container, { size: 'large' })
        const data = {
          patternId: this.localData.pattern?.id,
          productId: this.data?.entityId,
          count: this.localData.count
        }
        post(Endpoints.getUrl('sale.barcodeGenerator.generateBarcodeByProduct'), data)
          .then((res: IResponseList<ICodePattern>) => {
            this.resolve(res.data)
          })
          .catch((error: any) => {
            console.error(error)
          })
          .finally(() => {
            wait.end()
          })
      },
      generateProductFloatingBarcodes() {
        var wait = this.$wait(this.$refs.container, { size: 'large' })
        const data = {
          patternId: this.localData.pattern?.id,
          productId: this.data?.entityId,
          count: this.localData.count,
          productFloatingJsonIds: (this.data?.productFloatings || []).map((x: any) => x.id)
        }
        post(Endpoints.getUrl('sale.barcodeGenerator.generateBarcodeByProductFloating'), data)
          .then((res: IResponseList<ICodePattern>) => {
            this.resolve(res.data)
          })
          .catch((error: any) => {
            console.error(error)
          })
          .finally(() => {
            wait.end()
          })
      }
    },
    mounted() {
      this.prepareWindow(this.$t(`sale.product.f.productBarcode.generateByPattern`), this.pageButtons)
      this.getCodePatternListData()
    },
    computed: {
      beautyPatternItems() {
        if (!this.localData.pattern?.codePatternRules?.length)
          return []
        let items = this.localData.pattern.codePatternRules.map((cpr: ICodePatternRule) => {
          let extraItems = []
          if (cpr.min)
            extraItems.push({ title: this.$t('core.code-pattern.f.min'), value: cpr.min })
          if (cpr.value)
            extraItems.push({ title: this.$t('core.code-pattern.f.value'), value: cpr.value })
          if (cpr.direction)
            extraItems.push({ title: this.$t('core.code-pattern.f.direction'), value: cpr.direction === 'r' ? this.$t('core.code-pattern.f.right') : cpr.direction === 'l' ? this.$t('core.code-pattern.f.left') : cpr.direction })
          if (cpr.productFloating)
            extraItems.push({ title: this.$t('core.code-pattern.f.floatingTitle'), value: cpr.productFloating })
          return {
            title: ['static', 'counter'].includes(cpr.key?.toLowerCase() || '') ? this.$t(`core.code-pattern.f.${cpr.key?.toLowerCase()}`) : this.$t(`core.code-pattern.items.${this.localData.pattern?.entityType}.props.${cpr.key}`),
            extraItems: extraItems
          }
        })
        return items
      }
    }
  })
</script>
<style scoped
  lang="less">
    .pattern-box {
      padding: 2px;
      border-radius: 5px;
      border: 1px solid #ddd;
      display: flex;
      flex-wrap: wrap;
      height: 54px;
      direction: ltr;

      .pattern-item {
        background-color: antiquewhite;
        padding: 2px;
        border-radius: 5px;
        border: 1px dashed orange;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .pattern-item-title {
          font-size: 11px;
          padding: 2px;
          font-weight: bold;
          text-align: center;
        }

        .pattern-item-extra-items {
          font-size: 10px;
          padding: 2px;
          font-weight: bold;
          display: flex;
          color: grey;
          justify-content: space-between;
          border-top: 1px dashed orange;
          direction: rtl;

          .pattern-item-extra-item {
            margin: 0 2px;
          }
        }
      }
    }

  </style>